/* SIDIZ configurator — variant switching for the PDP head.

   Reads the variant JSON printed by the section, resolves the selected option
   combination, and updates the price, SKU, hero image, add-to-cart state and
   URL. Options that lead to no variant at all are disabled rather than left
   selectable, so the shopper cannot reach a dead combination. */

(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return format ? format.replace(/\{\{\s*amount\s*\}\}/, amount) : '$' + amount;
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function loadDeferredImage(img) {
    if (!img) return;
    if (img.dataset.sidizGallerySrc) {
      img.src = img.dataset.sidizGallerySrc;
      img.removeAttribute('data-sidiz-gallery-src');
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
  }

  function init(root) {
    if (root.dataset.sidizConfiguratorReady === 'true') return;
    root.dataset.sidizConfiguratorReady = 'true';

    var dataEl = root.querySelector('[data-sidiz-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!variants || !variants.length) return;

    var inputs = Array.prototype.slice.call(
      root.querySelectorAll('.product-variant__input')
    );
    if (!inputs.length) return;

    var priceEl = root.querySelector('[data-sidiz-price]');
    var skuEls = Array.prototype.slice.call(
      root.querySelectorAll('[data-sidiz-sku]')
    );
    var idEl = root.querySelector('[data-sidiz-variant-id]');
    var atc = root.querySelector('.add-to-cart');
    var atcLabel = root.querySelector('[data-sidiz-atc-label]');
    var preorderActive = root.dataset.sidizPreorderActive === 'true';
    var preorderReady = root.dataset.sidizPreorderReady === 'true';
    var availableLabel = preorderActive
      ? root.dataset.sidizPreorderLabel || 'Pre-order'
      : root.dataset.sidizAtcDefaultLabel || 'Add to cart';
    var preorderUnavailableLabel =
      root.dataset.sidizPreorderUnavailableLabel || 'Pre-order unavailable';
    var images = Array.prototype.slice.call(root.querySelectorAll('.variant-image'));
    var colourMedia = Array.prototype.slice.call(
      root.querySelectorAll('[data-sidiz-colour-media]')
    );
    var variantHeroes = Array.prototype.slice.call(
      root.querySelectorAll('.variant-media')
    );
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function shouldUseCompactVariantGallery() {
      var colourInputs = root.querySelectorAll('[data-sidiz-colour-option]');
      var desktopWrapper = root.querySelector('.product-gallery.web .product-media--wrapper');
      var extraMedia = desktopWrapper
        ? desktopWrapper.querySelectorAll(':scope > .product-media--item:not(.variant-media)').length
        : 0;
      var variantIds = new Set(
        images
          .map(function (img) { return img.dataset.variantId || ''; })
          .filter(Boolean)
      );
      var displayedModel = root.querySelector('.product-title');
      var modelName = displayedModel ? displayedModel.textContent.trim().toLowerCase() : '';

      // The Spring T50 layout uses its additional gallery tiles as large colour
      // swatches. Compact only that structure: normal lifestyle galleries and
      // colour-specific 360 preview galleries keep their existing layout.
      return modelName === 't50' &&
        colourInputs.length > 1 &&
        variantIds.size > 2 &&
        extraMedia > 1 &&
        colourMedia.length === 0;
    }

    var compactVariantGallery = shouldUseCompactVariantGallery();
    var productPath = window.location.pathname.match(/\/products\/([^/]+)/);
    var animatedVariantGallery = !compactVariantGallery && productPath && [
      't90-ergonomic-office-chair',
      'sidiz-t50-2nd-generation-ergonomic-office-chair',
      'sidiz-ringo-gen2-growing-kids-chair',
      'sidiz-gx-joy-explorer-ergonomic-gaming-chair'
    ].indexOf(productPath[1]) !== -1;

    var moneyFormat =
      (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';

    function selection() {
      var chosen = [];
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var pos = parseInt(input.dataset.optionPosition, 10);
        chosen[pos - 1] = input.value;
      });
      return chosen;
    }

    function matches(variant, chosen) {
      return chosen.every(function (value, i) {
        return value === undefined || variant.options[i] === value;
      });
    }

    function syncColourMedia() {
      if (!colourMedia.length) return;
      var colourInput = root.querySelector('[data-sidiz-colour-option]:checked');
      var colour = colourInput ? handleize(colourInput.value) : '';
      var sku = root.dataset.sidizCurrentSku || '';
      var colourMatches = colourMedia.filter(function (item) {
        return colour && item.dataset.colour === colour;
      });
      var skuMatch = colourMatches.filter(function (item) {
        return item.dataset.skuContains && sku.includes(item.dataset.skuContains);
      })[0];
      var selectedSet = (skuMatch || colourMatches[0] || colourMedia[0]).dataset.spinSet;

      colourMedia.forEach(function (item) {
        var active = item.dataset.spinSet === selectedSet;
        item.classList.toggle('hidden', !active);
        if (active) loadDeferredImage(item.querySelector('img'));
      });

      root.querySelectorAll('.product-gallery.mobile').forEach(function (gallery) {
        if (gallery.swiper && typeof gallery.swiper.update === 'function') gallery.swiper.update();
      });
    }

    function heroImages(hero) {
      return Array.prototype.slice.call(hero.querySelectorAll('.variant-image'));
    }

    function updateVariantThumbnails(variant) {
      root.querySelectorAll('[data-sidiz-variant-thumbnail]').forEach(function (button) {
        var active = String(button.dataset.variantId) === String(variant.id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setVariantImagesImmediately(variant) {
      variantHeroes.forEach(function (hero) {
        var group = heroImages(hero);
        var target = group.filter(function (img) {
          return String(img.dataset.variantId) === String(variant.id);
        })[0] || group[0];

        group.forEach(function (img) {
          var active = img === target;
          img.classList.toggle('hidden', !active);
          img.classList.toggle('is-active', active);
          img.classList.remove('is-entering', 'is-exiting');
          img.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        loadDeferredImage(target);
      });
      updateVariantThumbnails(variant);
    }

    function variantImageStatus(hero, message) {
      var status = hero.querySelector('.sidiz-variant-image-status');
      if (!status && message) {
        status = document.createElement('p');
        status.className = 'sidiz-variant-image-status';
        status.setAttribute('role', 'status');
        hero.appendChild(status);
      }
      if (status) {
        status.textContent = message || '';
        status.hidden = !message;
      }
    }

    function snapVariantHero(hero, target) {
      hero.classList.add('sidiz-variant-snap');
      heroImages(hero).forEach(function (img) {
        var active = img === target;
        img.classList.toggle('hidden', !active);
        img.classList.toggle('is-active', active);
        img.classList.remove('is-entering', 'is-exiting');
        img.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      hero.classList.remove('sidiz-variant-moving');
      // Commit the settled state before enabling another transition.
      void hero.offsetWidth;
      hero.classList.remove('sidiz-variant-snap');
    }

    function variantHeroIsDisplayed(hero) {
      var rect = hero.getBoundingClientRect();
      if (!rect.width || !rect.height || window.getComputedStyle(hero).visibility === 'hidden') return false;
      var gallery = hero.closest('.product-gallery.mobile');
      if (gallery && gallery.swiper && gallery.swiper.slides) {
        return gallery.swiper.slides[gallery.swiper.activeIndex] === hero;
      }
      return true;
    }

    function prepareVariantImage(img) {
      var cancel;
      var ready = new Promise(function (resolve) {
        var done = false;
        var timer;
        function finish(ok) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          img.removeEventListener('load', loaded);
          img.removeEventListener('error', failed);
          resolve(ok);
        }
        function failed() { finish(false); }
        function loaded() {
          if (!img.naturalWidth) { failed(); return; }
          if (typeof img.decode === 'function') {
            img.decode().then(function () { finish(img.naturalWidth > 0); }, failed);
          } else {
            finish(true);
          }
        }
        cancel = failed;
        timer = window.setTimeout(failed, 20000);
        img.addEventListener('load', loaded);
        img.addEventListener('error', failed);
        // A display:none lazy image would otherwise wait until after the swap.
        img.loading = 'eager';
        loadDeferredImage(img);
        if (img.complete) loaded();
      });
      return { ready: ready, cancel: cancel };
    }

    function transitionLoadedVariantImages(variant) {
      variantHeroes.forEach(function (hero) {
        var sequence = (hero.sidizVariantSequence || 0) + 1;
        hero.sidizVariantSequence = sequence;
        if (hero.sidizVariantLoadCancel) hero.sidizVariantLoadCancel();
        if (hero.sidizVariantTimer) window.clearTimeout(hero.sidizVariantTimer);
        if (hero.sidizVariantFrame) window.cancelAnimationFrame(hero.sidizVariantFrame);

        var group = heroImages(hero);
        var current = group.filter(function (img) {
          return img.classList.contains('is-active') && !img.classList.contains('hidden');
        })[0];
        var target = group.filter(function (img) {
          return String(img.dataset.variantId) === String(variant.id);
        })[0];
        if (current) snapVariantHero(hero, current);
        variantImageStatus(hero, '');
        hero.setAttribute('aria-busy', 'true');

        function stillCurrent() {
          return root.isConnected && hero.sidizVariantSequence === sequence;
        }
        function imageFailed() {
          if (!stillCurrent()) return;
          hero.setAttribute('aria-busy', 'false');
          variantImageStatus(hero, 'Image unavailable for this option. Previous image shown.');
        }
        if (!target) { imageFailed(); return; }

        var pending = prepareVariantImage(target);
        hero.sidizVariantLoadCancel = pending.cancel;
        pending.ready.then(function (loaded) {
          if (!stillCurrent()) return;
          hero.sidizVariantLoadCancel = null;
          if (!loaded) { imageFailed(); return; }
          hero.setAttribute('aria-busy', 'false');
          var motionReduced = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (current === target || !current || motionReduced || !variantHeroIsDisplayed(hero)) {
            snapVariantHero(hero, target);
            return;
          }

          hero.classList.add('sidiz-variant-moving');
          target.classList.remove('hidden', 'is-active', 'is-exiting');
          target.classList.add('is-entering');
          hero.sidizVariantFrame = window.requestAnimationFrame(function () {
            hero.sidizVariantFrame = window.requestAnimationFrame(function () {
              if (!stillCurrent()) return;
              current.classList.remove('is-active');
              current.classList.add('is-exiting');
              current.setAttribute('aria-hidden', 'true');
              target.classList.remove('is-entering');
              target.classList.add('is-active');
              target.setAttribute('aria-hidden', 'false');
              hero.sidizVariantTimer = window.setTimeout(function () {
                if (stillCurrent()) snapVariantHero(hero, target);
              }, 340);
            });
          });
        });
      });
      updateVariantThumbnails(variant);
    }

    function transitionVariantImages(variant) {
      if (animatedVariantGallery) {
        transitionLoadedVariantImages(variant);
        return;
      }
      if (!compactVariantGallery || reduceMotion) {
        setVariantImagesImmediately(variant);
        return;
      }

      variantHeroes.forEach(function (hero) {
        var group = heroImages(hero);
        var target = group.filter(function (img) {
          return String(img.dataset.variantId) === String(variant.id);
        })[0] || group[0];
        var current = group.filter(function (img) {
          return img.classList.contains('is-active') && !img.classList.contains('hidden');
        })[0] || group.filter(function (img) {
          return !img.classList.contains('hidden');
        })[0];

        if (!target) return;
        loadDeferredImage(target);

        if (current === target) {
          target.classList.remove('hidden', 'is-entering', 'is-exiting');
          target.classList.add('is-active');
          target.setAttribute('aria-hidden', 'false');
          return;
        }

        if (hero.sidizVariantTimer) window.clearTimeout(hero.sidizVariantTimer);

        group.forEach(function (img) {
          if (img === current || img === target) return;
          img.classList.add('hidden');
          img.classList.remove('is-active', 'is-entering', 'is-exiting');
          img.setAttribute('aria-hidden', 'true');
        });

        if (current) {
          current.classList.remove('is-active', 'is-entering');
          current.classList.add('is-exiting');
          current.setAttribute('aria-hidden', 'true');
        }

        target.classList.remove('hidden', 'is-active', 'is-exiting');
        target.classList.add('is-entering');
        target.setAttribute('aria-hidden', 'false');

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            target.classList.remove('is-entering');
            target.classList.add('is-active');
          });
        });

        hero.sidizVariantTimer = window.setTimeout(function () {
          if (current) {
            current.classList.add('hidden');
            current.classList.remove('is-exiting');
          }
        }, 520);
      });

      updateVariantThumbnails(variant);
    }

    function buildVariantThumbnailRail(hero) {
      var group = heroImages(hero);
      if (group.length < 2) return;

      var rail = document.createElement('div');
      rail.className = 'sidiz-variant-thumbnails';
      rail.setAttribute('role', 'group');
      rail.setAttribute('aria-label', 'Product colour previews');

      group.forEach(function (img) {
        if (!img.dataset.variantId) return;
        var variant = variants.filter(function (candidate) {
          return String(candidate.id) === String(img.dataset.variantId);
        })[0];
        if (!variant) return;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sidiz-variant-thumbnail';
        button.dataset.sidizVariantThumbnail = '';
        button.dataset.variantId = variant.id;
        button.setAttribute('aria-label', 'View ' + variant.title);
        button.setAttribute('aria-pressed', 'false');

        var preview = document.createElement('img');
        preview.src = img.dataset.src || img.currentSrc || img.src;
        preview.alt = '';
        preview.width = 96;
        preview.height = 96;
        preview.loading = 'lazy';
        preview.decoding = 'async';
        button.appendChild(preview);

        var label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = variant.title;
        button.appendChild(label);

        button.addEventListener('click', function () {
          syncInputs(variant);
          refreshAvailability(selection());
          render(variant);
        });
        rail.appendChild(button);
      });

      var mobileGallery = hero.closest('.product-gallery.mobile');
      if (mobileGallery) {
        mobileGallery.appendChild(rail);
      } else {
        hero.insertAdjacentElement('afterend', rail);
      }
    }

    function initialiseCompactVariantGallery() {
      if (!compactVariantGallery) return;
      root.classList.add('sidiz-compact-variant-gallery');
      variantHeroes.forEach(function (hero) {
        hero.dataset.sidizVariantHero = '';
        buildVariantThumbnailRail(hero);
      });

      root.querySelectorAll('.product-gallery.mobile').forEach(function (gallery) {
        if (gallery.swiper && typeof gallery.swiper.update === 'function') gallery.swiper.update();
      });
    }

    function find(chosen) {
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], chosen)) return variants[i];
      }
      return null;
    }

    // Disable option values that cannot combine with the selection made so far.
    //
    // Only the options BEFORE this one constrain it. Constraining by the later
    // options too would disable most of the first option — picking a material
    // would be blocked because the currently selected colour is not offered in
    // it, when in reality choosing that material simply moves you to a
    // different colour.
    function refreshAvailability(chosen) {
      inputs.forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10);
        var probe = chosen.slice(0, pos - 1);
        probe[pos - 1] = input.value;
        var ok = !!find(probe);
        // `disabled` is a class in the KR sheet, not just the attribute: inside
        // .product-variants--hide-unavailable it hides the value entirely,
        // which is how kr.sidiz.com behaves — choosing a leather leaves only
        // the leather colours on screen.
        input.classList.toggle('disabled', !ok);
        input.disabled = !ok;
      });
    }

    function render(variant) {
      if (priceEl) {
        var html =
          '<div class="discount--details-top">' +
          (variant.compare_at_price && variant.compare_at_price > variant.price
            ? '<span class="product-discount--percent">' +
              Math.round(
                ((variant.compare_at_price - variant.price) /
                  variant.compare_at_price) *
                  100
              ) +
              '%</span>'
            : '') +
          '<span class="product-price--best">' +
          money(variant.price, moneyFormat) +
          '</span></div>' +
          (variant.compare_at_price && variant.compare_at_price > variant.price
            ? '<s class="product-price--original">' +
              money(variant.compare_at_price, moneyFormat) +
              '</s>'
            : '');
        priceEl.innerHTML = html;
      }

      skuEls.forEach(function (skuEl) {
        skuEl.textContent = variant.sku || '';
      });
      root.dataset.sidizCurrentSku = variant.sku || '';
      if (idEl) idEl.value = variant.id;

      if (atc) {
        atc.disabled = !variant.available || (preorderActive && !preorderReady);
        if (atcLabel) {
          atcLabel.textContent =
            preorderActive && !preorderReady
              ? preorderUnavailableLabel
              : variant.available
                ? availableLabel
                : 'Sold out';
        }
      }

      transitionVariantImages(variant);
      syncColourMedia();

      root.querySelectorAll('[data-sidiz-option-value]').forEach(function (el) {
        var pos = parseInt(el.dataset.sidizOptionValue, 10);
        el.textContent = variant.options[pos - 1] || '';
      });

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function syncInputs(variant) {
      inputs.forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10);
        input.checked = variant.options[pos - 1] === input.value;
      });
    }

    function onChange(event) {
      var chosen = selection();
      var variant = find(chosen);

      if (!variant) {
        // The combination does not exist — usually because the shopper changed
        // an early option and the later ones no longer apply. Honour the option
        // they just touched and everything before it, then let the rest follow.
        var changedPos = event && event.target
          ? parseInt(event.target.dataset.optionPosition, 10)
          : 1;
        var prefix = chosen.slice(0, changedPos);
        variant =
          variants.filter(function (candidate) {
            return candidate.available && matches(candidate, prefix);
          })[0] ||
          variants.filter(function (candidate) {
            return matches(candidate, prefix);
          })[0];
        if (variant) syncInputs(variant);
      }

      refreshAvailability(selection());
      if (variant) {
        render(variant);
        root.dispatchEvent(new CustomEvent('sidiz:variant-selected', { detail: { id: variant.id } }));
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });

    initialiseCompactVariantGallery();
    if (animatedVariantGallery) root.classList.add('sidiz-animated-variant-gallery');
    refreshAvailability(selection());
    var initialVariant = find(selection()) || variants[0];
    if (initialVariant) setVariantImagesImmediately(initialVariant);
    syncColourMedia();
  }

  function boot(scope) {
    (scope || document)
      .querySelectorAll('[data-sidiz-configurator]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
